import React, { useEffect, useMemo } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import { Indicator, ToolTip } from 'design-system';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { formatAmount } from '../utils';
import { useCurrentPrice } from '../hooks/selectors';
import { selectTradingAccount } from '../reducers/selectors';
import { getLimitPriceAndTotalCostForLimitBuy } from '../utils/format';
export const strings = {
    buyTitle: 'Total cost (est.)',
    latestPrice: 'Latest price: ',
    tooltipTitle: 'Why is this estimated?',
    tooltipText: 'The amount you will buy for is based on the latest price - if the price has changed at the moment you place your order, the amount you buy may change too.',
};
const AmountPreview = ({ assetId, loading, numberOfShares, quantityInputRef, fxConversion }) => {
    const currentPrice = useCurrentPrice(assetId);
    const tradingAccount = useAppSelector(selectTradingAccount);
    const availableToInvest = tradingAccount?.account.availableToInvest;
    const colors = useColors();
    const styles = useStyles(styleSet);
    const totalAmount = useMemo(() => getLimitPriceAndTotalCostForLimitBuy(numberOfShares || 0, currentPrice, fxConversion), [currentPrice, fxConversion, numberOfShares]);
    useEffect(() => {
        // This hook is needed to clear the input if the current price updates and exceeds available to invest
        if (totalAmount.totalAmount.value && availableToInvest) {
            if (totalAmount.totalAmount.value > availableToInvest.value) {
                quantityInputRef.current?.clear();
            }
        }
    }, [availableToInvest, quantityInputRef, totalAmount.totalAmount.value]);
    if (!currentPrice) {
        return null;
    }
    return (<View style={styles.container}>
      <View>
        <View style={styles.row}>
          <Text Text-14>{strings.buyTitle}</Text>
          <Spacer w={4}/>
          <ToolTip title={strings.tooltipTitle} subtitle={strings.tooltipText} colorKey="secondary" small offset={1}/>
        </View>
        <Text NumbersThin-14 Secondary>
          <Text TextThin-14 Secondary>
            {strings.latestPrice}
          </Text>
          {formatAmount(currentPrice)}
        </Text>
      </View>
      <Spacer w={8}/>
      {loading ? (<Indicator style={styles.loadingIndicator} color={colors.text.secondary}/>) : (<Text Numbers-16 flex right numberOfLines={1}>
          {formatAmount(totalAmount.totalAmount)}
        </Text>)}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        height: rem(60),
        paddingHorizontal: rem(16),
        marginHorizontal: rem(16),
        borderRadius: rem(9),
        backgroundColor: colors.cards.onLight,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    loadingIndicator: {
        flex: 1,
        backgroundColor: 'transparent',
        alignItems: 'flex-end',
    },
}));
export default AmountPreview;
